import React from "react";
import { useTranslation } from "react-i18next";
import CallToActiion from "../components/common/CallToActiion";
import Features from "../components/common/Features";
import Services from "../components/common/Services";
import States from "../components/common/States";
import Testimonials from "../components/common/Testimonials";

const Home = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-indigo-600 to-indigo-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              <span className="text-orange-400">Premium</span> Kitchen Solutions
            </h1>
            <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
              Transform your kitchen with our exclusive range of high-quality
              appliances designed for modern Indian homes.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-6 border border-orange-300">
                <h3 className="text-2xl font-bold mb-2 text-orange-300">
                  Electric Chimneys
                </h3>
                <p className="text-lg">Advanced smoke extraction technology</p>
              </div>
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-6 border border-orange-300">
                <h3 className="text-2xl font-bold mb-2 text-orange-300">
                  Gas Stoves
                </h3>
                <p className="text-lg">Professional cooking performance</p>
              </div>
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-6 border border-orange-300">
                <h3 className="text-2xl font-bold mb-2 text-orange-300">
                  Modern Design
                </h3>
                <p className="text-lg">Sleek aesthetics for your kitchen</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      <div className="bg-white py-16">
        <CallToActiion t={t} i18n={i18n} />
      </div>

      {/* Features Section */}
      <div className="bg-gray-50 py-16">
        <Features />
      </div>

      {/* Services Section */}
      <div className="bg-white py-16">
        <Services />
      </div>

      {/* Testimonials Section */}
      <div className="bg-white py-16">
        <Testimonials />
      </div>
    </div>
  );
};

export default Home;
